module.exports = __webpack_public_path__ + "static/media/img23.09d3095f.JPG";